class Recover extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector('form');
    }

    connectedCallback() {
        this.fillEmailField()
    }

    fillEmailField() {
        const loginElement = document.querySelector('w3-login#login')
        const recoverLink = loginElement.querySelector('.js-recover-password')
        const email = loginElement.querySelector('input[name="customer[email]"]')
        let emailValue = email.value

        recoverLink.addEventListener('click', () => {
            emailValue = email.value
            if(this.validateEmail(emailValue)) {
                this.form.querySelector('input[name="email"]').value = emailValue
            }
        })
    }

    validateEmail(string) {
        return String(string)
            .toLowerCase()
            .match(
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    }
}
customElements.define('w3-recover', Recover);
